import React from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import RenderIf from '../../../../renderIf';

const StatusBox = ({ status, lastUpdated, children, justify, labelAction }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    return (
        <Box>
            <Box>
                <Box sx={{ display: 'flex', justifyContent: !!justify ? justify : 'flex-start', alignItems: 'center' }}>
                    <Box
                        className={classes.dot}
                        sx={{ backgroundColor: status?.hex || status?.displayColor || 'black' }}
                    />
                    <Box>
                        <Typography className={classes.status}>
                            {status?.description || ''}
                            {status?.label ? t(status.label) : ''}
                            {labelAction}
                        </Typography>
                        {children}
                    </Box>
                </Box>
                <Box>
                    <RenderIf isTrue={lastUpdated}>
                        <Typography
                            className={classes.lastUpdated}
                            variant="secondary"
                        >
                            Updated on {lastUpdated}
                        </Typography>
                    </RenderIf>
                </Box>
            </Box>
        </Box>
    );
};

export default StatusBox;

export const useStyles = makeStyles((theme) => ({
    dot: {
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        marginRight: '6px',
    },
    lastUpdated: {
        color: theme.palette.grey.secondary,
        fontSize: '10px',
        fontWeight: 400,
    },
    status: {
        color: '#231C32',
        fontSize: '13px',
    },
}));
